
// import { useEffect, useMemo, useState } from "react";

// const forthcomingEvents = [
//   { title: "3rd India International Fintech Festival", date: "07 Aug, 2026", category: "Fintech Festival", accent: "Festival", type: "Summit" },
//   { title: "Invest in Odisha Roadshow", date: "19 Aug, 2026", category: "Investment Roadshow", accent: "Business", type: "Roadshow" },
//   { title: "Farm to Foreign Conclave", date: "19 Aug, 2026", category: "Agriculture Conclave", accent: "Export", type: "Conclave" },
//   { title: "23rd International Tax Conference", date: "20 Aug, 2026", category: "Tax Conference", accent: "Finance", type: "Conference" },
//   { title: "2nd edition of GUJARAT CHEMICAL & PETROCHEMICAL CONCLAVE", date: "20 Aug, 2026", category: "Chemical Conclave", accent: "Industry", type: "Conclave" },
//   { title: "ASSOCHAM IX National Summit & Awards on Corporate Bond Market", date: "21 Aug, 2026", category: "Bond Market Summit", accent: "Awards", type: "Awards" },
//   { title: "10th Edition of The Edu Meet 2026 & Excellence Awards", date: "25 Aug, 2026", category: "Education Meet", accent: "Recognition", type: "Awards" },
//   { title: "National Conference on Aerospace & Defence Manufacturing", date: "09 Sep-12 Sep, 2026", category: "Manufacturing Conference", accent: "Defence", type: "Conference" },
//   { title: "MobilityNext 2047 - Driving Innovation, Partnerships and Policy for Electric Mobility", date: "30 Oct, 2026", category: "Mobility Summit", accent: "Innovation", type: "Summit" },
//   { title: "5th IP Excellence Awards 2026", date: "31 Oct, 2026", category: "IP Awards", accent: "Excellence", type: "Awards" },
//   { title: "4th AgriTech: Smart Farming | Sustainable Future", date: "31 Dec, 2026", category: "AgriTech Forum", accent: "Sustainability", type: "Forum" },
//   { title: "3rd Edition of Manufacturing Conclave & Manufacturing Excellence Awards 2026", date: "31 Dec, 2026", category: "Manufacturing Conclave", accent: "Leadership", type: "Awards" },
// ];

// const pastEvents = [
//   { title: "1st Edition of Growth Driven Family Business Conclave & Excellence Awards 2026", date: "24 Jun, 2026", category: "Family Business Conclave", accent: "Growth", type: "Awards" },
//   { title: "4th Edition of Minerals and Mining Conclave 2026", date: "19 Jun, 2026", category: "Mining Conclave", accent: "Resources", type: "Conclave" },
//   { title: "Telangana Clean Energy Summit 2026", date: "18 Jun, 2026", category: "Energy Summit", accent: "Clean Energy", type: "Summit" },
//   { title: "ASSOCHAM National Conclave on Future of Financial Governance", date: "17 Jun, 2026", category: "Governance Conclave", accent: "Policy", type: "Conclave" },
//   { title: "ASSOCHAM 2nd Pharma Summit & Awards 2026", date: "11 Jun, 2026", category: "Pharma Summit", accent: "Healthcare", type: "Awards" },
//   { title: "2nd Edition MahaMSMErashtra Empowerment Summit", date: "10 Jun, 2026", category: "MSME Summit", accent: "Empowerment", type: "Summit" },
//   { title: "6th edition of The Health Meet & Excellence Awards 2026", date: "29 May, 2026", category: "Health Meet", accent: "Awards", type: "Awards" },
//   { title: "ASSOCHAM Rajasthan Education Summit 2026: Empowering Rajasthan through AI-Driven Education & Vision 2030", date: "29 May, 2026", category: "Education Summit", accent: "AI", type: "Summit" },
//   { title: "10th ASSOCHAM Smart Datacenters, Cloud & AI Summit 2026", date: "28 May, 2026", category: "Technology Summit", accent: "Cloud & AI", type: "Summit" },
//   { title: "India Speciality Chemicals Conclave - Speciality Chemicals for Economic Growth and Job Creation", date: "21 May, 2026", category: "Chemical Conclave", accent: "Economic Growth", type: "Conclave" },
//   { title: "India Business Reform Summit 2026", date: "19 May, 2026", category: "Business Summit", accent: "Reforms", type: "Summit" },
//   { title: "ASSOCHAM's National Seminar on New Labour Codes", date: "13 May, 2026", category: "National Seminar", accent: "Labour Codes", type: "Seminar" },
// ];

// const allEvents = [
//   ...forthcomingEvents.map((e) => ({ ...e, status: "forthcoming" })),
//   ...pastEvents.map((e) => ({ ...e, status: "past" })),
// ];

// function AnimatedNumber({ value, duration = 900 }) {
//   const [display, setDisplay] = useState(0);
//   useEffect(() => {
//     let raf;
//     const start = performance.now();
//     const from = 0;
//     const to = value;
//     const tick = (now) => {
//       const progress = Math.min((now - start) / duration, 1);
//       const eased = 1 - Math.pow(1 - progress, 3);
//       setDisplay(Math.round(from + (to - from) * eased));
//       if (progress < 1) raf = requestAnimationFrame(tick);
//     };
//     raf = requestAnimationFrame(tick);
//     return () => cancelAnimationFrame(raf);
//   }, [value, duration]);
//   return <span>{display}</span>;
// }

// function CalendarBadge({ date, active }) {
//   const parts = date.split(" ");
//   const dayPart = parts[0];
//   const restPart = parts.slice(1).join(" ");
//   const [monthPart] = restPart.split(",");
//   const yearMatch = date.match(/(20\d{2})/);
//   const year = yearMatch ? yearMatch[1] : "2026";

//   return (
//     <div className="relative mx-auto flex w-[88px] shrink-0 flex-col overflow-hidden rounded-[18px] border border-white/80 bg-white shadow-[0_10px_28px_rgba(219,38,40,0.12)] transition-all duration-500 group-hover:-translate-y-1.5 group-hover:rotate-[-1deg] group-hover:shadow-[0_18px_40px_rgba(219,38,40,0.18)] sm:mx-0">
//       <div className="absolute left-3 top-0 h-2.5 w-2.5 -translate-y-1/2 rounded-full border border-[#DA2128]/30 bg-[#FEF7F4] transition duration-500 group-hover:bg-[#F59C00]" />
//       <div className="absolute right-3 top-0 h-2.5 w-2.5 -translate-y-1/2 rounded-full border border-[#DA2128]/30 bg-[#FEF7F4] transition duration-500 group-hover:bg-[#F59C00]" />
//       <div className="event-card-shine pointer-events-none absolute inset-0" />
//       <div className="relative bg-gradient-to-br from-white to-[#FAF7F2] px-2.5 py-3 text-center">
//         <div className="font-heading text-[1.55rem] font-black leading-none text-[#1F1630]">{dayPart}</div>
//         <div className="mt-1.5 text-[0.65rem] font-extrabold uppercase tracking-[0.22em] text-[#DB6400]">{monthPart}</div>
//       </div>
//       <div
//         className={`relative px-2.5 py-2 text-center text-[0.7rem] font-extrabold tracking-[0.18em] text-white ${
//           active ? "bg-gradient-to-r from-[#DA2128] to-[#F59C00]" : "bg-gradient-to-r from-[#DB2628] to-[#DB6400]"
//         }`}
//       >
//         <span className="relative z-10">{year}</span>
//       </div>
//     </div>
//   );
// }

// function EventCard({ event, active, index }) {
//   const delay = `${Math.min(index * 70, 600)}ms`;
//   return (
//     <article
//       style={{ animationDelay: delay }}
//       className="event-fade-up group relative overflow-hidden rounded-[24px] border border-[#DA2128]/10 bg-white/90 p-4 shadow-[0_12px_32px_rgba(218,33,40,0.07)] backdrop-blur-sm transition-all duration-500 hover:-translate-y-1.5 hover:border-[#DA2128]/25 hover:shadow-[0_20px_48px_rgba(218,33,40,0.14)] sm:p-5"
//     >
//       <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(245,156,0,0.12),transparent_32%),radial-gradient(circle_at_bottom_left,rgba(218,33,40,0.1),transparent_35%)] opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
//       <div className="pointer-events-none absolute -left-1/2 top-0 h-full w-1/2 -rotate-12 bg-[linear-gradient(115deg,transparent,rgba(255,255,255,0.8),transparent)] opacity-0 transition-all duration-700 group-hover:left-[120%] group-hover:opacity-100" />
//       <div className="event-glow-border pointer-events-none absolute inset-0 rounded-[24px] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

//       <div className="relative flex flex-col gap-4 sm:flex-row sm:items-start">
//         <CalendarBadge date={event.date} active={active} />
//         <div className="min-w-0 flex-1 space-y-3">
//           <div className="flex flex-wrap items-center gap-2">
//             <span className="inline-flex rounded-full bg-[#FAF7F2] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#DA2128] transition duration-300 group-hover:scale-105">
//               {event.category}
//             </span>
//             <span className="inline-flex rounded-full border border-[#DB6400]/25 bg-[#FEF7F4] px-2.5 py-1 text-[0.7rem] font-bold text-[#DB6400] transition duration-300 group-hover:-translate-y-0.5">
//               {event.accent}
//             </span>
//             <span className="inline-flex items-center gap-1.5 rounded-full border border-[#B8A6A2]/30 bg-[#FAF7F2] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#8E7B77]">
//               {event.type}
//             </span>
//             {active ? (
//               <span className="event-live-pill inline-flex items-center gap-1.5 rounded-full bg-[#FFF0EC] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#DA2128]">
//                 <span className="relative flex h-2 w-2">
//                   <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#DA2128] opacity-75" />
//                   <span className="relative inline-flex h-2 w-2 rounded-full bg-[#DA2128]" />
//                 </span>
//                 Upcoming
//               </span>
//             ) : (
//               <span className="inline-flex items-center gap-1.5 rounded-full border border-[#B8A6A2]/30 bg-[#FAF7F2] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#8E7B77]">
//                 Archived
//               </span>
//             )}
//           </div>

//           <h3 className="font-heading text-[1.05rem] font-extrabold leading-snug text-[#161224] transition-all duration-500 group-hover:translate-x-0.5 group-hover:text-[#DA2128] sm:text-[1.15rem]">
//             {event.title}
//           </h3>

//           <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
//             <div className="flex items-center gap-2.5 rounded-full bg-[#FFFDFC] px-3 py-1.5 text-[0.8rem] font-semibold text-[#5C5569] shadow-sm transition duration-300 group-hover:shadow-md">
//               <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#F59C00] text-white shadow-[0_6px_14px_rgba(218,33,40,0.22)]">
//                 <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
//                   <path d="M8 2v4" />
//                   <path d="M16 2v4" />
//                   <rect x="3" y="5" width="18" height="16" rx="2" />
//                   <path d="M3 10h18" />
//                 </svg>
//               </span>
//               <span>{event.date}</span>
//             </div>

//             <button
//               type="button"
//               className="event-btn inline-flex w-fit items-center gap-1.5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-4 py-2 text-[0.8rem] font-bold text-white shadow-[0_10px_22px_rgba(218,33,40,0.22)] transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_14px_28px_rgba(218,33,40,0.3)] active:scale-[0.98]"
//             >
//               <span>{active ? "Register Interest" : "View Highlights"}</span>
//               <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="2.2">
//                 <path d="M5 12h14" />
//                 <path d="m13 5 7 7-7 7" />
//               </svg>
//             </button>
//           </div>
//         </div>
//       </div>
//     </article>
//   );
// }

// function SelectField({ label, value, options, onChange, placeholder = "Select", icon }) {
//   return (
//     <div className="space-y-1.5">
//       <label className="text-[0.8rem] font-bold text-[#251B35]">{label}</label>
//       <div className="relative">
//         {icon && <div className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-[#DA2128]">{icon}</div>}
//         <select
//           value={value}
//           onChange={(e) => onChange(e.target.value)}
//           className={`w-full appearance-none rounded-xl border border-[#DA2128]/10 bg-[#FFFCFA] py-2.5 pr-10 text-[0.8rem] font-medium text-[#554C64] transition duration-300 hover:border-[#DA2128]/30 hover:bg-white focus:border-[#DA2128] focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10 ${
//             icon ? "pl-10" : "pl-3.5"
//           }`}
//         >
//           <option value="">{placeholder}</option>
//           {options.map((opt) => (
//             <option key={opt} value={opt}>
//               {opt}
//             </option>
//           ))}
//         </select>
//         <svg viewBox="0 0 24 24" className="pointer-events-none absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[#352B46]" fill="none" stroke="currentColor" strokeWidth="2">
//           <path d="m6 9 6 6 6-6" />
//         </svg>
//       </div>
//     </div>
//   );
// }

// function BackgroundFX() {
//   return (
//     <>
//       <div className="event-blob event-blob-one" />
//       <div className="event-blob event-blob-two" />
//       <div className="event-blob event-blob-three" />
//       <div
//         className="pointer-events-none absolute inset-0 opacity-[0.22]"
//         style={{
//           backgroundImage:
//             "linear-gradient(rgba(218,33,40,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(218,33,40,0.05) 1px, transparent 1px)",
//           backgroundSize: "30px 30px",
//           maskImage: "radial-gradient(circle at 50% 20%, black 0%, transparent 70%)",
//           WebkitMaskImage: "radial-gradient(circle at 50% 20%, black 0%, transparent 70%)",
//         }}
//       />
//       <div className="pointer-events-none absolute left-[5%] top-[18%] h-24 w-24 rounded-full bg-[#F59C00]/10 blur-3xl animate-[floaty_8s_ease-in-out_infinite]" />
//       <div className="pointer-events-none absolute right-[8%] top-[40%] h-28 w-28 rounded-full bg-[#DA2128]/10 blur-3xl animate-[floaty_9s_ease-in-out_infinite_reverse]" />
//     </>
//   );
// }

// /* ---------------- BREADCRUMB ---------------- */
// function Breadcrumb() {
//   return (
//     <nav
//       aria-label="Breadcrumb"
//       className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
//     >
//       <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
//         <li>
//           <a
//             href="#top"
//             className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
//           >
//             <svg
//               viewBox="0 0 24 24"
//               className="h-4 w-4"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2.2}
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path d="M3 10.5 12 3l9 7.5" />
//               <path d="M5 10v10h14V10" />
//               <path d="M9 20v-6h6v6" />
//             </svg>
//             Home
//           </a>
//         </li>

//         <li className="text-black/30">&rsaquo;</li>
//         <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">Event</li>
//       </ol>
//     </nav>
//   );
// }

// export default function EventPage() {
//   const [activeTab, setActiveTab] = useState("forthcoming");

//   const [draftTab, setDraftTab] = useState("forthcoming");
//   const [draftKeywords, setDraftKeywords] = useState("");
//   const [draftEventType, setDraftEventType] = useState("");
//   const [draftEventDate, setDraftEventDate] = useState("");
//   const [draftSubject, setDraftSubject] = useState("");
//   const [draftLanguage, setDraftLanguage] = useState("");
//   const [draftOnlineType, setDraftOnlineType] = useState("");
//   const [draftRegions, setDraftRegions] = useState("");

//   const [applied, setApplied] = useState({
//     tab: "forthcoming",
//     keywords: "",
//     eventType: "",
//     eventDate: "",
//     subject: "",
//     language: "",
//     onlineType: "",
//     regions: "",
//   });

//   const [animKey, setAnimKey] = useState(0);

//   const eventTypes = useMemo(() => {
//     const set = new Set(allEvents.map((e) => e.type));
//     return Array.from(set);
//   }, []);

//   const subjects = useMemo(() => {
//     const set = new Set(allEvents.map((e) => e.accent));
//     return Array.from(set);
//   }, []);

//   const languages = ["English", "Hindi", "Bilingual"];
//   const onlineTypes = ["In-Person", "Virtual", "Hybrid"];
//   const regions = ["Delhi NCR", "Mumbai", "Odisha", "Gujarat", "Telangana", "Rajasthan", "Pan-India"];

//   const applyFilters = (next) => {
//     setApplied(next);
//     setActiveTab(next.tab);
//     setDraftTab(next.tab);
//     setAnimKey((k) => k + 1);
//   };

//   const handleTab = (tab) => {
//     setActiveTab(tab);
//     setDraftTab(tab);
//     setApplied((prev) => ({ ...prev, tab }));
//     setAnimKey((k) => k + 1);
//   };

//   const handleSidebarStatus = (tab) => {
//     setDraftTab(tab);
//     setActiveTab(tab);
//     setApplied((prev) => ({
//       ...prev,
//       tab,
//       keywords: draftKeywords.trim(),
//       eventType: draftEventType,
//       eventDate: draftEventDate,
//       subject: draftSubject,
//       language: draftLanguage,
//       onlineType: draftOnlineType,
//       regions: draftRegions,
//     }));
//     setAnimKey((k) => k + 1);
//   };

//   const handleSearch = () => {
//     applyFilters({
//       tab: draftTab,
//       keywords: draftKeywords.trim(),
//       eventType: draftEventType,
//       eventDate: draftEventDate,
//       subject: draftSubject,
//       language: draftLanguage,
//       onlineType: draftOnlineType,
//       regions: draftRegions,
//     });
//   };

//   const handleClear = () => {
//     setDraftKeywords("");
//     setDraftEventType("");
//     setDraftEventDate("");
//     setDraftSubject("");
//     setDraftLanguage("");
//     setDraftOnlineType("");
//     setDraftRegions("");
//     setDraftTab("forthcoming");
//     applyFilters({
//       tab: "forthcoming",
//       keywords: "",
//       eventType: "",
//       eventDate: "",
//       subject: "",
//       language: "",
//       onlineType: "",
//       regions: "",
//     });
//   };

//   const activeEvents = useMemo(() => {
//     const base = applied.tab === "forthcoming" ? forthcomingEvents : pastEvents;
//     const kw = applied.keywords.toLowerCase();
//     return base.filter((e) => {
//       if (applied.eventType && e.type !== applied.eventType) return false;
//       if (applied.subject && e.accent !== applied.subject) return false;
//       if (kw) {
//         const hay = `${e.title} ${e.category} ${e.accent}`.toLowerCase();
//         if (!hay.includes(kw)) return false;
//       }
//       return true;
//     });
//   }, [applied]);

//   const totalCount = activeEvents.length;
//   const showingEnd = Math.min(10, totalCount);
//   const statusLabel = applied.tab === "forthcoming" ? "Upcoming & ongoing" : "Completed archive";
//   const headerLabel = applied.tab === "forthcoming" ? "Forthcoming Industry Events" : "Recently Concluded Events";
 
//   return (
//     <div id="top" className="event-page-shell min-h-screen bg-[linear-gradient(180deg,#FEF7F4_0%,#FFFFFF_42%,#FAF7F2_100%)] text-[#1A1427]">
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700;9..144,800;9..144,900&display=swap');

//         .font-heading,
//         .event-page-shell h1,
//         .event-page-shell h2,
//         .event-page-shell h3 {
//           font-family: Fraunces, Georgia, "Times New Roman", serif !important;
//         }

//         @keyframes blob-float { 0%, 100% { transform: translate(0,0) scale(1); } 33% { transform: translate(22px,-28px) scale(1.05); } 66% { transform: translate(-18px,22px) scale(0.96); } }
//         @keyframes blob-morph { 0%, 100% { border-radius: 42% 58% 63% 37% / 46% 40% 60% 54%; } 50% { border-radius: 58% 42% 40% 60% / 54% 60% 40% 46%; } }
//         @keyframes fade-up { 0% { opacity: 0; transform: translateY(22px); } 100% { opacity: 1; transform: translateY(0); } }
//         @keyframes fade-in { 0% { opacity: 0; } 100% { opacity: 1; } }
//         @keyframes shimmer { 0% { transform: translateX(-140%) skewX(-18deg); } 100% { transform: translateX(220%) skewX(-18deg); } }
//         @keyframes floaty { 0%, 100% { transform: translateY(0) translateX(0); } 50% { transform: translateY(-14px) translateX(8px); } }
//         @keyframes pulse-glow { 0%, 100% { box-shadow: 0 0 0 0 rgba(245,156,0,0.3); } 50% { box-shadow: 0 0 0 10px rgba(245,156,0,0); } }

//         .event-blob { position: absolute; filter: blur(50px); opacity: 0.5; animation: blob-float 12s ease-in-out infinite, blob-morph 14s ease-in-out infinite; }
//         .event-blob-one { width: 300px; height: 300px; top: -70px; left: -90px; background: radial-gradient(circle, rgba(218,33,40,0.22), rgba(218,33,40,0) 68%); }
//         .event-blob-two { width: 360px; height: 360px; top: 12%; right: -120px; background: radial-gradient(circle, rgba(245,156,0,0.18), rgba(245,156,0,0) 70%); animation-delay: -3s; }
//         .event-blob-three { width: 280px; height: 280px; bottom: -100px; left: 20%; background: radial-gradient(circle, rgba(219,100,0,0.15), rgba(219,100,0,0) 70%); animation-delay: -6s; }
//         .event-fade-up { animation: fade-up 0.6s cubic-bezier(.2,.8,.2,1) both; }
//         .event-fade-in { animation: fade-in 0.4s ease both; }
//         .event-card-shine::before { content: ""; position: absolute; inset: 0; background: linear-gradient(120deg, transparent 30%, rgba(255,255,255,.7) 50%, transparent 70%); transform: translateX(-140%) skewX(-18deg); opacity: 0; transition: opacity .3s ease; }
//         .group:hover .event-card-shine::before { animation: shimmer 1s ease forwards; opacity: 1; }
//         .event-glow-border { border: 1.5px solid transparent; background: linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, rgba(218,33,40,0.55), rgba(245,156,0,0.55)) border-box; }
//         .event-live-pill { animation: pulse-glow 2.4s infinite; }

//         .event-btn {
//           background-image: linear-gradient(to right, #DA2128, #F59C00);
//           background-size: 100% 100%;
//           border: none;
//           cursor: pointer;
//         }
//         .event-btn:hover {
//           filter: brightness(1.05);
//         }
//         .event-btn:active {
//           filter: brightness(0.95);
//         }

//         .floating { animation: floaty 6s ease-in-out infinite; }
//         .floating-slow { animation: floaty 10s ease-in-out infinite reverse; }
//         .hero-in { animation: fade-up 0.7s cubic-bezier(.2,.8,.2,1) both; }
//         .breadcrumb-in { animation: fade-in 0.5s ease both; }
//       `}</style>

//       {/* ---------- HERO ---------- */}
//       <header className="relative overflow-hidden bg-gradient-to-r from-[#DA2128] via-[#DB6400] to-[#F59C00] py-16 text-center text-white sm:py-20">
//         <Breadcrumb />
//         <span className="floating absolute -left-10 top-8 h-40 w-40 rounded-full bg-white/10" />
//         <span className="floating-slow absolute -right-8 bottom-0 h-52 w-52 rounded-full bg-white/10" />
//         <span className="floating absolute left-1/3 top-2 h-14 w-14 rounded-full bg-white/10" />
//         <div className="hero-in relative mx-auto max-w-3xl px-4">
//           <p className="text-xs font-bold uppercase tracking-[0.35em] text-white/80">
//             Stay ahead of the industry calendar
//           </p>
//           <h1 className="mt-3 text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
//             ASSOCHAM Events
//           </h1>
//           <div className="mx-auto mt-5 h-1 w-24 rounded-full bg-white/70" />
//         </div>
//       </header>

//       <section className="relative overflow-hidden">
//         <BackgroundFX />
//         <div className="relative mx-auto max-w-7xl px-3 py-8 sm:px-5 lg:px-7 lg:py-12">
//           <div className="grid gap-6 lg:grid-cols-[300px_minmax(0,1fr)] xl:grid-cols-[320px_minmax(0,1fr)]">
//             {/* Sidebar */}
//             <aside className="event-fade-up rounded-[26px] border border-[#DA2128]/10 bg-white/85 p-5 shadow-[0_18px_44px_rgba(218,33,40,0.08)] backdrop-blur-xl lg:sticky lg:top-5 lg:h-fit">
//               <div className="mb-5 flex items-center justify-between border-b border-[#DA2128]/10 pb-3.5">
//                 <div>
//                   <p className="text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-[#DB6400]">Filter by</p>
//                   <h2 className="text-balance font-display text-3xl md:text-[32px] leading-tight text-gray-900 mt-5">Events Search</h2>
//                 </div>
//                 <div className="rounded-xl bg-gradient-to-br from-[#FFE3DA] to-[#FFE7CF] px-2.5 py-1.5 text-[0.65rem] font-extrabold text-[#DA2128] shadow-sm">Smart</div>
//               </div>

//               <div className="space-y-3.5">
//                 <div className="space-y-1.5">
//                   <label className="text-[0.8rem] font-bold text-[#251B35]">Keywords</label>
//                   <div className="relative">
//                     <svg viewBox="0 0 24 24" className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" fill="none" stroke="currentColor" strokeWidth="2">
//                       <circle cx="11" cy="11" r="7" />
//                       <path d="m20 20-3.5-3.5" />
//                     </svg>
//                     <input
//                       type="text"
//                       value={draftKeywords}
//                       onChange={(e) => setDraftKeywords(e.target.value)}
//                       onKeyDown={(e) => e.key === "Enter" && handleSearch()}
//                       placeholder="Search by title, sector, theme..."
//                       className="w-full rounded-xl border border-[#DA2128]/10 bg-[#FFFCFA] py-2.5 pl-10 pr-3.5 text-[0.8rem] font-medium text-[#2B2139] transition duration-300 placeholder:text-[#9A8F9F] hover:border-[#DA2128]/30 hover:bg-white focus:border-[#DA2128] focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
//                     />
//                   </div>
//                 </div>

//                 <div className="space-y-1.5">
//                   <label className="text-[0.8rem] font-bold text-[#251B35]">Status</label>
//                   <div className="flex gap-1.5 rounded-xl border border-[#DA2128]/10 bg-[#FFFCFA] p-1">
//                     <button
//                       type="button"
//                       onClick={() => handleSidebarStatus("forthcoming")}
//                       className={`flex-1 rounded-lg px-2.5 py-2 text-[0.8rem] font-bold transition duration-300 ${
//                         draftTab === "forthcoming"
//                           ? "bg-gradient-to-r from-[#DA2128] to-[#F59C00] text-white shadow-[0_8px_18px_rgba(218,33,40,0.22)]"
//                           : "text-[#574D64] hover:bg-[#FAF7F2]"
//                       }`}
//                     >
//                       Forthcoming
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => handleSidebarStatus("past")}
//                       className={`flex-1 rounded-lg px-2.5 py-2 text-[0.8rem] font-bold transition duration-300 ${
//                         draftTab === "past"
//                           ? "bg-gradient-to-r from-[#DB2628] to-[#DB6400] text-white shadow-[0_8px_18px_rgba(219,38,40,0.18)]"
//                           : "text-[#574D64] hover:bg-[#FAF7F2]"
//                       }`}
//                     >
//                       Past
//                     </button>
//                   </div>
//                 </div>

//                 <SelectField label="Event type" value={draftEventType} options={eventTypes} onChange={setDraftEventType} placeholder="Select event type" />
//                 <SelectField
//                   label="Event date"
//                   value={draftEventDate}
//                   options={["This Week", "This Month", "Next 3 Months", "This Quarter", "This Year"]}
//                   onChange={setDraftEventDate}
//                   placeholder="Select date range"
//                 />
//                 <SelectField label="Subject" value={draftSubject} options={subjects} onChange={setDraftSubject} placeholder="Select subject" />
//                 {/* <SelectField label="Language" value={draftLanguage} options={languages} onChange={setDraftLanguage} placeholder="Select language" /> */}
//                 <SelectField label="Online type" value={draftOnlineType} options={onlineTypes} onChange={setDraftOnlineType} placeholder="Select format" />
//                 <SelectField label="Regions" value={draftRegions} options={regions} onChange={setDraftRegions} placeholder="Select region" />
//               </div>

//               <div className="mt-6 flex flex-col gap-2.5 sm:flex-row">
//                 <button
//                   type="button"
//                   onClick={handleSearch}
//                   className="event-btn inline-flex flex-1 items-center justify-center gap-1.5 rounded-xl px-4 py-2.5 text-[0.85rem] font-bold text-white shadow-[0_12px_26px_rgba(218,33,40,0.24)] transition duration-300 hover:-translate-y-0.5"
//                 >
//                   <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.4">
//                     <circle cx="11" cy="11" r="7" />
//                     <path d="m20 20-3.5-3.5" />
//                   </svg>
//                   Search
//                 </button>
//                 <button
//                   type="button"
//                   onClick={handleClear}
//                   className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-[#DA2128]/20 bg-white px-4 py-2.5 text-[0.85rem] font-bold text-[#DA2128] transition duration-300 hover:bg-[#FEF7F4]"
//                 >
//                   <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
//                     <path d="M3 6h18" />
//                     <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
//                     <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
//                   </svg>
//                   Clear filters
//                 </button>
//               </div>

//               <div className="mt-5 rounded-xl border border-[#F59C00]/20 bg-[#FFF8F1] p-3.5">
//                 <p className="text-[0.65rem] font-extrabold uppercase tracking-[0.2em] text-[#DB6400]">Need assistance?</p>
//                 <p className="mt-1.5 text-[0.8rem] leading-5 text-[#5C5569]">
//                   Looking to partner, sponsor, or nominate for an awards category? Connect with the events desk.
//                 </p>
//                 <button type="button" className="mt-3 inline-flex items-center gap-1.5 text-[0.8rem] font-extrabold text-[#DA2128] transition hover:gap-2.5">
//                   Contact Team
//                   <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
//                     <path d="M5 12h14" />
//                     <path d="m13 5 7 7-7 7" />
//                   </svg>
//                 </button>
//               </div>
//             </aside>

//             {/* Main */}
//             <main className="space-y-5">
//               <div className="event-fade-up rounded-[28px] border border-[#DA2128]/10 bg-white/90 p-5 shadow-[0_18px_44px_rgba(218,33,40,0.07)] backdrop-blur-xl sm:p-6">
//                 <div className="flex flex-col gap-5 border-b border-[#DA2128]/10 pb-5 lg:flex-row lg:items-end lg:justify-between">
//                   <div className="space-y-3">
//                     <span className="inline-flex items-center gap-1.5 rounded-full border border-[#DA2128]/15 bg-[#FEF7F4] px-3 py-1 text-[0.65rem] font-black uppercase tracking-[0.22em] text-[#DA2128]">
//                       <span className="h-1.5 w-1.5 rounded-full bg-[#DA2128] animate-pulse" />
//                       Premium Events Directory
//                     </span>
//                     <div>
//                       <h1 className="text-balance font-display text-3xl md:text-[32px] leading-tight text-gray-900 mt-5">
//                         {headerLabel}
//                       </h1>
                     
//                     </div>
//                   </div>

//                   <div className="relative flex items-center gap-1 self-start rounded-full border border-[#DA2128]/10 bg-[#FFFCFA] p-1 shadow-inner">
//                     <div
//                       className={`pointer-events-none absolute top-1 h-[calc(100%-8px)] w-[calc(62%-6px)] rounded-full shadow-[0_8px_18px_rgba(218,33,40,0.22)] transition-all duration-500 ease-[cubic-bezier(.2,.8,.2,1)] ${
//                         activeTab === "forthcoming"
//                           ? "left-1 bg-gradient-to-r from-[#DA2128] to-[#F59C00]"
//                           : "left-[calc(50%+1px)] bg-gradient-to-r from-[#DB2628] to-[#DB6400]"
//                       }`}
//                     />
//                     <button
//                       type="button"
//                       onClick={() => handleTab("forthcoming")}
//                       className={`relative z-10 rounded-full px-4 py-2 text-[0.8rem] font-bold transition-colors duration-300 ${
//                         activeTab === "forthcoming" ? "text-white" : "text-[#574D64] hover:text-[#DA2128]"
//                       }`}
//                     >
//                       Forthcoming
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => handleTab("past")}
//                       className={`relative z-10 rounded-full px-4 py-2 text-[0.8rem] font-bold transition-colors duration-300 ${
//                         activeTab === "past" ? "text-white" : "text-[#574D64] hover:text-[#DA2128]"
//                       }`}
//                     >
//                       Past Event
//                     </button>
//                   </div>
//                 </div>

//                 <div key={animKey} className="event-fade-in mt-5 flex flex-col gap-3.5 sm:flex-row sm:items-center sm:justify-between">
//                   <div className="flex flex-wrap items-center gap-4">
//                     {/* <div className="rounded-xl bg-[#FEF7F4] px-3.5 py-2.5">
//                       <p className="text-[0.65rem] font-bold uppercase tracking-[0.18em] text-[#DB6400]">Results</p>
//                       <p className="font-heading mt-0.5 text-2xl font-black text-[#0F0B1D]">
//                         <AnimatedNumber value={totalCount} />
//                       </p>
//                     </div> */}
//                     {/* <div>
//                       <h2 className="font-heading text-xl font-black text-[#0F0B1D]">Events ({totalCount})</h2>
//                       <p className="mt-0.5 text-[0.85rem] font-medium text-[#5D556A]">
//                         {totalCount === 0 ? "No events match your filters" : `Showing results 1 to ${showingEnd}`}
//                       </p>
//                     </div> */}
//                   </div>
//                   <div className="inline-flex items-center gap-1.5 rounded-full bg-[#EEF1FF] px-3.5 py-1.5 text-[0.8rem] font-semibold text-[#4B57B9] shadow-sm">
//                     <span className="inline-flex h-2 w-2 rounded-full bg-[#5A68D8] animate-pulse" />
//                     Status: {statusLabel}
//                   </div>
//                 </div>

//                 {applied.keywords || applied.eventType || applied.subject ? (
//                   <div className="mt-4 flex flex-wrap items-center gap-1.5">
//                     <span className="text-[0.65rem] font-bold uppercase tracking-[0.16em] text-[#8A7981]">Active filters:</span>
//                     {applied.keywords && (
//                       <span className="inline-flex items-center gap-1.5 rounded-full border border-[#DA2128]/20 bg-[#FEF7F4] px-2.5 py-0.5 text-[0.7rem] font-bold text-[#DA2128]">
//                         "{applied.keywords}"
//                       </span>
//                     )}
//                     {applied.eventType && (
//                       <span className="inline-flex items-center gap-1.5 rounded-full border border-[#DB6400]/20 bg-[#FFF8F1] px-2.5 py-0.5 text-[0.7rem] font-bold text-[#DB6400]">
//                         {applied.eventType}
//                       </span>
//                     )}
//                     {applied.subject && (
//                       <span className="inline-flex items-center gap-1.5 rounded-full border border-[#F59C00]/30 bg-[#FFF8F1] px-2.5 py-0.5 text-[0.7rem] font-bold text-[#B96200]">
//                         {applied.subject}
//                       </span>
//                     )}
//                   </div>
//                 ) : null}
//               </div>

//               <div key={`list-${animKey}`} className="grid gap-4">
//                 {activeEvents.length === 0 ? (
//                   <div className="event-fade-up rounded-[24px] border border-dashed border-[#DA2128]/25 bg-white/80 p-8 text-center shadow-[0_12px_32px_rgba(218,33,40,0.06)]">
//                     <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#F59C00] text-white shadow-[0_12px_24px_rgba(218,33,40,0.24)]">
//                       <svg viewBox="0 0 24 24" className="h-6 w-6 fill-none" stroke="currentColor" strokeWidth="2.2">
//                         <circle cx="11" cy="11" r="7" />
//                         <path d="m20 20-3.5-3.5" />
//                       </svg>
//                     </div>
//                     <h3 className="font-heading mt-4 text-xl font-black text-[#161224]">No matching events found</h3>
//                     <p className="mx-auto mt-2 max-w-md text-[0.85rem] leading-6 text-[#5D556A]">
//                       Try clearing some filters or switching the event status. Use broader keywords like fintech, awards, summit, or conclave.
//                     </p>
//                     <button
//                       type="button"
//                       onClick={handleClear}
//                       className="event-btn mt-5 inline-flex items-center gap-1.5 rounded-full px-5 py-2.5 text-[0.85rem] font-bold text-white shadow-[0_10px_22px_rgba(218,33,40,0.22)] transition hover:scale-[1.03]"
//                     >
//                       Reset all filters
//                     </button>
//                   </div>
//                 ) : (
//                   activeEvents.map((event, index) => (
//                     <EventCard
//                       key={`${activeTab}-${event.title}-${animKey}`}
//                       event={event}
//                       active={activeTab === "forthcoming"}
//                       index={index}
//                     />
//                   ))
//                 )}
//               </div>

//               <div className="event-fade-up relative overflow-hidden rounded-[24px] border border-[#DA2128]/10 bg-[linear-gradient(135deg,#DA2128_0%,#DB6400_55%,#F59C00_100%)] p-5 text-white shadow-[0_18px_44px_rgba(218,33,40,0.2)] sm:p-6">
//                 <div className="pointer-events-none absolute right-0 top-0 h-52 w-52 rounded-full bg-white/12 blur-3xl" />
//                 <div className="relative flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
//                   <div>
//                     <p className="text-[0.7rem] font-black uppercase tracking-[0.26em] text-white/80">Stay Updated</p>
//                     <h3 className="font-heading mt-1.5 text-xl font-black sm:text-2xl">Never miss the next flagship event</h3>
//                     <p className="mt-2 max-w-xl text-[0.85rem] leading-6 text-white/90">
//                       Follow major conclaves, conferences, roadshows, awards, and summits across business, fintech, education, healthcare, manufacturing, and policy sectors.
//                     </p>
//                   </div>
//                   <div className="flex flex-col gap-2.5 sm:flex-row">
//                     <button
//                       type="button"
//                       className="inline-flex w-fit items-center gap-1.5 rounded-full bg-white px-5 py-2.5 text-[0.85rem] font-bold text-[#DA2128] shadow-[0_10px_22px_rgba(0,0,0,0.14)] transition duration-300 hover:scale-[1.03]"
//                     >
//                       Get Event Alerts
//                       <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
//                         <path d="M5 12h14" />
//                         <path d="m13 5 7 7-7 7" />
//                       </svg>
//                     </button>
//                     <button
//                       type="button"
//                       className="inline-flex w-fit items-center gap-1.5 rounded-full border border-white/40 bg-white/10 px-5 py-2.5 text-[0.85rem] font-bold text-white backdrop-blur-sm transition duration-300 hover:bg-white/20"
//                     >
//                       Download Calendar
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </main>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }







// new code 




import React, { useEffect, useMemo, useState } from "react";

const eventImages = {
  "Fintech Festival": "/images/event-fintech.jpg",
  "Investment Roadshow": "/images/event-roadshow.jpg",
  "Agriculture Conclave": "/images/event-agriculture.jpg",
  "Tax Conference": "/images/event-general.jpg",
  "Chemical Conclave": "/images/event-chemical.jpg",
  "Bond Market Summit": "/images/event-corporate.jpg",
  "Education Meet": "/images/event-education.jpg",
  "Manufacturing Conference": "/images/event-manufacturing.jpg",
  "Mobility Summit": "/images/event-mobility.jpg",
  "IP Awards": "/images/event-general.jpg",
  "AgriTech Forum": "/images/event-agriculture.jpg",
  "Manufacturing Conclave": "/images/event-manufacturing.jpg",
  "Family Business Conclave": "/images/event-general.jpg",
  "Mining Conclave": "/images/event-mining.jpg",
  "Energy Summit": "/images/event-energy.jpg",
  "Governance Conclave": "/images/event-general.jpg",
  "Pharma Summit": "/images/event-pharma.jpg",
  "MSME Summit": "/images/event-general.jpg",
  "Health Meet": "/images/event-healthcare.jpg",
  "Education Summit": "/images/event-education.jpg",
  "Technology Summit": "/images/event-tech-ai.jpg",
  "Business Summit": "/images/event-general.jpg",
  "National Seminar": "/images/event-general.jpg",
};

const fallbackImages = [
  "/images/event-fintech.jpg",
  "/images/event-agriculture.jpg",
  "/images/event-chemical.jpg",
  "/images/event-education.jpg",
  "/images/event-healthcare.jpg",
  "/images/event-manufacturing.jpg",
  "/images/event-energy.jpg",
  "/images/event-tech-ai.jpg",
  "/images/event-mining.jpg",
  "/images/event-pharma.jpg",
];

const forthcomingEvents = [
  { title: "3rd India International Fintech Festival", date: "07 Aug, 2026", category: "Fintech Festival", accent: "Festival", type: "Summit" },
  { title: "Invest in Odisha Roadshow", date: "19 Aug, 2026", category: "Investment Roadshow", accent: "Business", type: "Roadshow" },
  { title: "Farm to Foreign Conclave", date: "19 Aug, 2026", category: "Agriculture Conclave", accent: "Export", type: "Conclave" },
  { title: "23rd International Tax Conference", date: "20 Aug, 2026", category: "Tax Conference", accent: "Finance", type: "Conference" },
  { title: "2nd edition of GUJARAT CHEMICAL & PETROCHEMICAL CONCLAVE", date: "20 Aug, 2026", category: "Chemical Conclave", accent: "Industry", type: "Conclave" },
  { title: "ASSOCHAM IX National Summit & Awards on Corporate Bond Market", date: "21 Aug, 2026", category: "Bond Market Summit", accent: "Awards", type: "Awards" },
  { title: "10th Edition of The Edu Meet 2026 & Excellence Awards", date: "25 Aug, 2026", category: "Education Meet", accent: "Recognition", type: "Awards" },
  { title: "National Conference on Aerospace & Defence Manufacturing", date: "09 Sep-12 Sep, 2026", category: "Manufacturing Conference", accent: "Defence", type: "Conference" },
  { title: "MobilityNext 2047 - Driving Innovation, Partnerships and Policy for Electric Mobility", date: "30 Oct, 2026", category: "Mobility Summit", accent: "Innovation", type: "Summit" },
  { title: "5th IP Excellence Awards 2026", date: "31 Oct, 2026", category: "IP Awards", accent: "Excellence", type: "Awards" },
  { title: "4th AgriTech: Smart Farming | Sustainable Future", date: "31 Dec, 2026", category: "AgriTech Forum", accent: "Sustainability", type: "Forum" },
  { title: "3rd Edition of Manufacturing Conclave & Manufacturing Excellence Awards 2026", date: "31 Dec, 2026", category: "Manufacturing Conclave", accent: "Leadership", type: "Awards" },
];

const pastEvents = [
  { title: "1st Edition of Growth Driven Family Business Conclave & Excellence Awards 2026", date: "24 Jun, 2026", category: "Family Business Conclave", accent: "Growth", type: "Awards" },
  { title: "4th Edition of Minerals and Mining Conclave 2026", date: "19 Jun, 2026", category: "Mining Conclave", accent: "Resources", type: "Conclave" },
  { title: "Telangana Clean Energy Summit 2026", date: "18 Jun, 2026", category: "Energy Summit", accent: "Clean Energy", type: "Summit" },
  { title: "ASSOCHAM National Conclave on Future of Financial Governance", date: "17 Jun, 2026", category: "Governance Conclave", accent: "Policy", type: "Conclave" },
  { title: "ASSOCHAM 2nd Pharma Summit & Awards 2026", date: "11 Jun, 2026", category: "Pharma Summit", accent: "Healthcare", type: "Awards" },
  { title: "2nd Edition MahaMSMErashtra Empowerment Summit", date: "10 Jun, 2026", category: "MSME Summit", accent: "Empowerment", type: "Summit" },
  { title: "6th edition of The Health Meet & Excellence Awards 2026", date: "29 May, 2026", category: "Health Meet", accent: "Awards", type: "Awards" },
  { title: "ASSOCHAM Rajasthan Education Summit 2026: Empowering Rajasthan through AI-Driven Education & Vision 2030", date: "29 May, 2026", category: "Education Summit", accent: "AI", type: "Summit" },
  { title: "10th ASSOCHAM Smart Datacenters, Cloud & AI Summit 2026", date: "28 May, 2026", category: "Technology Summit", accent: "Cloud & AI", type: "Summit" },
  { title: "India Speciality Chemicals Conclave - Speciality Chemicals for Economic Growth and Job Creation", date: "21 May, 2026", category: "Chemical Conclave", accent: "Economic Growth", type: "Conclave" },
  { title: "India Business Reform Summit 2026", date: "19 May, 2026", category: "Business Summit", accent: "Reforms", type: "Summit" },
  { title: "ASSOCHAM's National Seminar on New Labour Codes", date: "13 May, 2026", category: "National Seminar", accent: "Labour Codes", type: "Seminar" },
];

const allEvents = [
  ...forthcomingEvents.map((e) => ({ ...e, status: "forthcoming" })),
  ...pastEvents.map((e) => ({ ...e, status: "past" })),
];

function getEventImage(event, index) {
  const mapped = eventImages[event.category];
  if (mapped) return mapped;
  const title = event.title.toLowerCase();
  if (title.includes("fintech") || title.includes("bond") || title.includes("finance") || title.includes("tax")) return "/images/event-fintech.jpg";
  if (title.includes("agri") || title.includes("farm")) return "/images/event-agriculture.jpg";
  if (title.includes("chemical") || title.includes("petro")) return "/images/event-chemical.jpg";
  if (title.includes("edu") || title.includes("learn")) return "/images/event-education.jpg";
  if (title.includes("health") || title.includes("medical") || title.includes("pharma")) return "/images/event-healthcare.jpg";
  if (title.includes("manufactur") || title.includes("defence") || title.includes("aerospace") || title.includes("mobility") || title.includes("electric")) return "/images/event-manufacturing.jpg";
  if (title.includes("energy") || title.includes("clean") || title.includes("solar")) return "/images/event-energy.jpg";
  if (title.includes("tech") || title.includes("ai") || title.includes("cloud") || title.includes("data") || title.includes("digital")) return "/images/event-tech-ai.jpg";
  if (title.includes("min") || title.includes("resource")) return "/images/event-mining.jpg";
  return fallbackImages[index % fallbackImages.length];
}

function AnimatedNumber({ value, duration = 900 }) {
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    let raf;
    const start = performance.now();
    const from = 0;
    const to = value;
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.round(from + (to - from) * eased));
      if (progress < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);
  return <span>{display}</span>;
}

function EventImageCard({ event, active, index }) {
  const parts = event.date.split(" ");
  const dayPart = parts[0];
  const restPart = parts.slice(1).join(" ");
  const [monthPart] = restPart.split(",");
  const yearMatch = event.date.match(/(20\d{2})/);
  const year = yearMatch ? yearMatch[1] : "2026";
  const imageUrl = getEventImage(event, index);

  return (
    <div className="relative mx-auto flex h-[140px] w-[160px] shrink-0 overflow-hidden rounded-[18px] border border-white/20 shadow-[0_10px_28px_rgba(219,38,40,0.12)] transition-all duration-500 group-hover:-translate-y-1.5 group-hover:rotate-[-1deg] group-hover:shadow-[0_18px_40px_rgba(219,38,40,0.18)] sm:mx-0">
      <img
        src={imageUrl}
        alt={event.title}
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/10" />
      <div className="absolute left-3 top-2.5 z-10 h-2 w-2 rounded-full border border-white/30 bg-white/20 transition duration-500 group-hover:bg-[#F59C00]" />
      <div className="absolute right-3 top-2.5 z-10 h-2 w-2 rounded-full border border-white/30 bg-white/20 transition duration-500 group-hover:bg-[#F59C00]" />
      <div className="event-card-shine pointer-events-none absolute inset-0 z-[2]" />

      <div className="absolute bottom-0 left-0 right-0 z-[3] px-3 py-2.5 text-center">
        <div className="flex items-end justify-between">
          <div className="text-left">
            <div className="font-heading text-[1.7rem] font-black leading-none tracking-tight text-white drop-shadow-lg">
              {dayPart}
            </div>
            <div className="mt-0.5 text-[0.6rem] font-extrabold uppercase tracking-[0.2em] text-[#F59C00] drop-shadow">
              {monthPart}
            </div>
          </div>
          <div
            className={`rounded-lg px-2 py-1 text-[0.6rem] font-extrabold tracking-[0.14em] text-white ${
              active ? "bg-gradient-to-r from-[#DA2128] to-[#F59C00]" : "bg-gradient-to-r from-[#DB2628] to-[#DB6400]"
            }`}
          >
            {year}
          </div>
        </div>
      </div>

      <div className="absolute right-2 top-2 z-[3]">
        <span className="inline-block rounded-full bg-black/50 px-2 py-0.5 text-[0.55rem] font-bold uppercase tracking-[0.12em] text-white backdrop-blur-sm">
          {event.type}
        </span>
      </div>
    </div>
  );
}

function EventCard({ event, active, index }) {
  const delay = `${Math.min(index * 70, 600)}ms`;
  return (
    <article
      style={{ animationDelay: delay }}
      className="event-fade-up group relative overflow-hidden rounded-[24px] border border-[#DA2128]/10 bg-white/90 p-4 shadow-[0_12px_32px_rgba(218,33,40,0.07)] backdrop-blur-sm transition-all duration-500 hover:-translate-y-1.5 hover:border-[#DA2128]/25 hover:shadow-[0_20px_48px_rgba(218,33,40,0.14)] sm:p-5"
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(245,156,0,0.12),transparent_32%),radial-gradient(circle_at_bottom_left,rgba(218,33,40,0.1),transparent_35%)] opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
      <div className="pointer-events-none absolute -left-1/2 top-0 h-full w-1/2 -rotate-12 bg-[linear-gradient(115deg,transparent,rgba(255,255,255,0.8),transparent)] opacity-0 transition-all duration-700 group-hover:left-[120%] group-hover:opacity-100" />
      <div className="event-glow-border pointer-events-none absolute inset-0 rounded-[24px] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

      <div className="relative flex flex-col gap-4 sm:flex-row sm:items-start">
        <EventImageCard event={event} active={active} index={index} />

        <div className="min-w-0 flex-1 space-y-3">
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex rounded-full bg-[#FAF7F2] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#DA2128] transition duration-300 group-hover:scale-105">
              {event.category}
            </span>
            <span className="inline-flex rounded-full border border-[#DB6400]/25 bg-[#FEF7F4] px-2.5 py-1 text-[0.7rem] font-bold text-[#DB6400] transition duration-300 group-hover:-translate-y-0.5">
              {event.accent}
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full border border-[#B8A6A2]/30 bg-[#FAF7F2] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#8E7B77]">
              {event.type}
            </span>
            {active ? (
              <span className="event-live-pill inline-flex items-center gap-1.5 rounded-full bg-[#FFF0EC] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#DA2128]">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#DA2128] opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#DA2128]" />
                </span>
                Upcoming
              </span>
            ) : (
              <span className="inline-flex items-center gap-1.5 rounded-full border border-[#B8A6A2]/30 bg-[#FAF7F2] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#8E7B77]">
                Archived
              </span>
            )}
          </div>

          <h3 className="font-heading text-[1.05rem] font-extrabold leading-snug text-[#161224] transition-all duration-500 group-hover:translate-x-0.5 group-hover:text-[#DA2128] sm:text-[1.15rem]">
            {event.title}
          </h3>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-2.5 rounded-full bg-[#FFFDFC] px-3 py-1.5 text-[0.8rem] font-semibold text-[#5C5569] shadow-sm transition duration-300 group-hover:shadow-md">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#F59C00] text-white shadow-[0_6px_14px_rgba(218,33,40,0.22)]">
                <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
                  <path d="M8 2v4" />
                  <path d="M16 2v4" />
                  <rect x="3" y="5" width="18" height="16" rx="2" />
                  <path d="M3 10h18" />
                </svg>
              </span>
              <span>{event.date}</span>
            </div>

            <button
              type="button"
              className="event-btn inline-flex w-fit items-center gap-1.5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-4 py-2 text-[0.8rem] font-bold text-white shadow-[0_10px_22px_rgba(218,33,40,0.22)] transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_14px_28px_rgba(218,33,40,0.3)] active:scale-[0.98]"
            >
              <span>{active ? "Register Interest" : "View Highlights"}</span>
              <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="2.2">
                <path d="M5 12h14" />
                <path d="m13 5 7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}

function SelectField({ label, value, options, onChange, placeholder = "Select", icon }) {
  return (
    <div className="space-y-1.5">
      <label className="text-[0.8rem] font-bold text-[#251B35]">{label}</label>
      <div className="relative">
        {icon && <div className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-[#DA2128]">{icon}</div>}
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={`w-full appearance-none rounded-xl border border-[#DA2128]/10 bg-[#FFFCFA] py-2.5 pr-10 text-[0.8rem] font-medium text-[#554C64] transition duration-300 hover:border-[#DA2128]/30 hover:bg-white focus:border-[#DA2128] focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10 ${
            icon ? "pl-10" : "pl-3.5"
          }`}
        >
          <option value="">{placeholder}</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        <svg viewBox="0 0 24 24" className="pointer-events-none absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[#352B46]" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="m6 9 6 6 6-6" />
        </svg>
      </div>
    </div>
  );
}

function BackgroundFX() {
  return (
    <>
      <div className="event-blob event-blob-one" />
      <div className="event-blob event-blob-two" />
      <div className="event-blob event-blob-three" />
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.22]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(218,33,40,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(218,33,40,0.05) 1px, transparent 1px)",
          backgroundSize: "30px 30px",
          maskImage: "radial-gradient(circle at 50% 20%, black 0%, transparent 70%)",
          WebkitMaskImage: "radial-gradient(circle at 50% 20%, black 0%, transparent 70%)",
        }}
      />
      <div className="pointer-events-none absolute left-[5%] top-[18%] h-24 w-24 rounded-full bg-[#F59C00]/10 blur-3xl animate-[floaty_8s_ease-in-out_infinite]" />
      <div className="pointer-events-none absolute right-[8%] top-[40%] h-28 w-28 rounded-full bg-[#DA2128]/10 blur-3xl animate-[floaty_9s_ease-in-out_infinite_reverse]" />
    </>
  );
}

function Breadcrumb() {
  return (
    <nav
      aria-label="Breadcrumb"
      className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
    >
      <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
        <li>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </a>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">Event</li>
      </ol>
    </nav>
  );
}

export default function EventPage() {
  const [activeTab, setActiveTab] = useState("forthcoming");
  const [draftTab, setDraftTab] = useState("forthcoming");
  const [draftKeywords, setDraftKeywords] = useState("");
  const [draftEventType, setDraftEventType] = useState("");
  const [draftEventDate, setDraftEventDate] = useState("");
  const [draftSubject, setDraftSubject] = useState("");
  const [draftOnlineType, setDraftOnlineType] = useState("");
  const [draftRegions, setDraftRegions] = useState("");

  const [applied, setApplied] = useState({
    tab: "forthcoming",
    keywords: "",
    eventType: "",
    eventDate: "",
    subject: "",
    language: "",
    onlineType: "",
    regions: "",
  });

  const [animKey, setAnimKey] = useState(0);

  const eventTypes = useMemo(() => {
    const set = new Set(allEvents.map((e) => e.type));
    return Array.from(set);
  }, []);

  const subjects = useMemo(() => {
    const set = new Set(allEvents.map((e) => e.accent));
    return Array.from(set);
  }, []);

  const onlineTypes = ["In-Person", "Virtual", "Hybrid"];
  const regions = ["Delhi NCR", "Mumbai", "Odisha", "Gujarat", "Telangana", "Rajasthan", "Pan-India"];

  const applyFilters = (next) => {
    setApplied(next);
    setActiveTab(next.tab);
    setDraftTab(next.tab);
    setAnimKey((k) => k + 1);
  };

  const handleTab = (tab) => {
    setActiveTab(tab);
    setDraftTab(tab);
    setApplied((prev) => ({ ...prev, tab }));
    setAnimKey((k) => k + 1);
  };

  const handleSidebarStatus = (tab) => {
    setDraftTab(tab);
    setActiveTab(tab);
    setApplied((prev) => ({
      ...prev,
      tab,
      keywords: draftKeywords.trim(),
      eventType: draftEventType,
      eventDate: draftEventDate,
      subject: draftSubject,
      onlineType: draftOnlineType,
      regions: draftRegions,
    }));
    setAnimKey((k) => k + 1);
  };

  const handleSearch = () => {
    applyFilters({
      tab: draftTab,
      keywords: draftKeywords.trim(),
      eventType: draftEventType,
      eventDate: draftEventDate,
      subject: draftSubject,
      onlineType: draftOnlineType,
      regions: draftRegions,
    });
  };

  const handleClear = () => {
    setDraftKeywords("");
    setDraftEventType("");
    setDraftEventDate("");
    setDraftSubject("");
    setDraftOnlineType("");
    setDraftRegions("");
    setDraftTab("forthcoming");
    applyFilters({
      tab: "forthcoming",
      keywords: "",
      eventType: "",
      eventDate: "",
      subject: "",
      language: "",
      onlineType: "",
      regions: "",
    });
  };

  const activeEvents = useMemo(() => {
    const base = applied.tab === "forthcoming" ? forthcomingEvents : pastEvents;
    const kw = applied.keywords.toLowerCase();
    return base.filter((e) => {
      if (applied.eventType && e.type !== applied.eventType) return false;
      if (applied.subject && e.accent !== applied.subject) return false;
      if (kw) {
        const hay = `${e.title} ${e.category} ${e.accent}`.toLowerCase();
        if (!hay.includes(kw)) return false;
      }
      return true;
    });
  }, [applied]);

  const totalCount = activeEvents.length;
  const statusLabel = applied.tab === "forthcoming" ? "Upcoming & ongoing" : "Completed archive";
  const headerLabel = applied.tab === "forthcoming" ? "Forthcoming Industry Events" : "Recently Concluded Events";

  return (
    <div id="top" className="event-page-shell min-h-screen bg-[linear-gradient(180deg,#FEF7F4_0%,#FFFFFF_42%,#FAF7F2_100%)] text-[#1A1427]">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700;9..144,800;9..144,900&display=swap');

        .font-heading,
        .event-page-shell h1,
        .event-page-shell h2,
        .event-page-shell h3 {
          font-family: Fraunces, Georgia, "Times New Roman", serif !important;
        }

        @keyframes blob-float { 0%, 100% { transform: translate(0,0) scale(1); } 33% { transform: translate(22px,-28px) scale(1.05); } 66% { transform: translate(-18px,22px) scale(0.96); } }
        @keyframes blob-morph { 0%, 100% { border-radius: 42% 58% 63% 37% / 46% 40% 60% 54%; } 50% { border-radius: 58% 42% 40% 60% / 54% 60% 40% 46%; } }
        @keyframes fade-up { 0% { opacity: 0; transform: translateY(22px); } 100% { opacity: 1; transform: translateY(0); } }
        @keyframes fade-in { 0% { opacity: 0; } 100% { opacity: 1; } }
        @keyframes shimmer { 0% { transform: translateX(-140%) skewX(-18deg); } 100% { transform: translateX(220%) skewX(-18deg); } }
        @keyframes floaty { 0%, 100% { transform: translateY(0) translateX(0); } 50% { transform: translateY(-14px) translateX(8px); } }
        @keyframes pulse-glow { 0%, 100% { box-shadow: 0 0 0 0 rgba(245,156,0,0.3); } 50% { box-shadow: 0 0 0 10px rgba(245,156,0,0); } }

        .event-blob { position: absolute; filter: blur(50px); opacity: 0.5; animation: blob-float 12s ease-in-out infinite, blob-morph 14s ease-in-out infinite; }
        .event-blob-one { width: 300px; height: 300px; top: -70px; left: -90px; background: radial-gradient(circle, rgba(218,33,40,0.22), rgba(218,33,40,0) 68%); }
        .event-blob-two { width: 360px; height: 360px; top: 12%; right: -120px; background: radial-gradient(circle, rgba(245,156,0,0.18), rgba(245,156,0) 70%); animation-delay: -3s; }
        .event-blob-three { width: 280px; height: 280px; bottom: -100px; left: 20%; background: radial-gradient(circle, rgba(219,100,0,0.15), rgba(219,100,0) 70%); animation-delay: -6s; }
        .event-fade-up { animation: fade-up 0.6s cubic-bezier(.2,.8,.2,1) both; }
        .event-fade-in { animation: fade-in 0.4s ease both; }
        .event-card-shine::before { content: ""; position: absolute; inset: 0; background: linear-gradient(120deg, transparent 30%, rgba(255,255,255,.7) 50%, transparent 70%); transform: translateX(-140%) skewX(-18deg); opacity: 0; transition: opacity .3s ease; }
        .group:hover .event-card-shine::before { animation: shimmer 1s ease forwards; opacity: 1; }
        .event-glow-border { border: 1.5px solid transparent; background: linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, rgba(218,33,40,0.55), rgba(245,156,0,0.55)) border-box; }
        .event-live-pill { animation: pulse-glow 2.4s infinite; }

        .event-btn {
          background-image: linear-gradient(to right, #DA2128, #F59C00);
          background-size: 100% 100%;
          border: none;
          cursor: pointer;
        }
        .event-btn:hover { filter: brightness(1.05); }
        .event-btn:active { filter: brightness(0.95); }

        .floating { animation: floaty 6s ease-in-out infinite; }
        .floating-slow { animation: floaty 10s ease-in-out infinite reverse; }
        .hero-in { animation: fade-up 0.7s cubic-bezier(.2,.8,.2,1) both; }
        .breadcrumb-in { animation: fade-in 0.5s ease both; }
      `}</style>

      {/* ---------- HERO ---------- */}
      <header className="relative overflow-hidden bg-gradient-to-r from-[#DA2128] via-[#DB6400] to-[#F59C00] py-16 text-center text-white sm:py-20">
        <Breadcrumb />
        <span className="floating absolute -left-10 top-8 h-40 w-40 rounded-full bg-white/10" />
        <span className="floating-slow absolute -right-8 bottom-0 h-52 w-52 rounded-full bg-white/10" />
        <span className="floating absolute left-1/3 top-2 h-14 w-14 rounded-full bg-white/10" />
        <div className="hero-in relative mx-auto max-w-3xl px-4">
          <p className="text-xs font-bold uppercase tracking-[0.35em] text-white/80">
            Stay ahead of the industry calendar
          </p>
          <h1 className="mt-3 text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
            ASSOCHAM Events
          </h1>
          <div className="mx-auto mt-5 h-1 w-24 rounded-full bg-white/70" />
        </div>
      </header>

      <section className="relative overflow-hidden">
        <BackgroundFX />
        <div className="relative mx-auto max-w-7xl px-3 py-8 sm:px-5 lg:px-7 lg:py-12">
          <div className="grid gap-6 lg:grid-cols-[300px_minmax(0,1fr)] xl:grid-cols-[320px_minmax(0,1fr)]">
            {/* Sidebar */}
            <aside className="event-fade-up rounded-[26px] border border-[#DA2128]/10 bg-white/85 p-5 shadow-[0_18px_44px_rgba(218,33,40,0.08)] backdrop-blur-xl lg:sticky lg:top-5 lg:h-fit">
              <div className="mb-5 flex items-center justify-between border-b border-[#DA2128]/10 pb-3.5">
                <div>
                  <p className="text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-[#DB6400]">Filter by</p>
                  <h2 className="mt-1 font-heading text-xl font-extrabold text-[#1F1630]">Events Search</h2>
                </div>
                <div className="rounded-xl bg-gradient-to-br from-[#FFE3DA] to-[#FFE7CF] px-2.5 py-1.5 text-[0.65rem] font-extrabold text-[#DA2128] shadow-sm">Smart</div>
              </div>

              <div className="space-y-3.5">
                <div className="space-y-1.5">
                  <label className="text-[0.8rem] font-bold text-[#251B35]">Keywords</label>
                  <div className="relative">
                    <svg viewBox="0 0 24 24" className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="11" cy="11" r="7" />
                      <path d="m20 20-3.5-3.5" />
                    </svg>
                    <input
                      type="text"
                      value={draftKeywords}
                      onChange={(e) => setDraftKeywords(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                      placeholder="Search by title, sector, theme..."
                      className="w-full rounded-xl border border-[#DA2128]/10 bg-[#FFFCFA] py-2.5 pl-10 pr-3.5 text-[0.8rem] font-medium text-[#2B2139] transition duration-300 placeholder:text-[#9A8F9F] hover:border-[#DA2128]/30 hover:bg-white focus:border-[#DA2128] focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
                    />
                  </div>
                </div>

                <div className="space-y-1.5">
                  <label className="text-[0.8rem] font-bold text-[#251B35]">Status</label>
                  <div className="flex gap-1.5 rounded-xl border border-[#DA2128]/10 bg-[#FFFCFA] p-1">
                    <button
                      type="button"
                      onClick={() => handleSidebarStatus("forthcoming")}
                      className={`flex-1 rounded-lg px-2.5 py-2 text-[0.8rem] font-bold transition duration-300 ${
                        draftTab === "forthcoming"
                          ? "bg-gradient-to-r from-[#DA2128] to-[#F59C00] text-white shadow-[0_8px_18px_rgba(218,33,40,0.22)]"
                          : "text-[#574D64] hover:bg-[#FAF7F2]"
                      }`}
                    >
                      Forthcoming
                    </button>
                    <button
                      type="button"
                      onClick={() => handleSidebarStatus("past")}
                      className={`flex-1 rounded-lg px-2.5 py-2 text-[0.8rem] font-bold transition duration-300 ${
                        draftTab === "past"
                          ? "bg-gradient-to-r from-[#DB2628] to-[#DB6400] text-white shadow-[0_8px_18px_rgba(219,38,40,0.18)]"
                          : "text-[#574D64] hover:bg-[#FAF7F2]"
                      }`}
                    >
                      Past
                    </button>
                  </div>
                </div>

                <SelectField label="Event type" value={draftEventType} options={eventTypes} onChange={setDraftEventType} placeholder="Select event type" />
                <SelectField
                  label="Event date"
                  value={draftEventDate}
                  options={["This Week", "This Month", "Next 3 Months", "This Quarter", "This Year"]}
                  onChange={setDraftEventDate}
                  placeholder="Select date range"
                />
                <SelectField label="Subject" value={draftSubject} options={subjects} onChange={setDraftSubject} placeholder="Select subject" />
                <SelectField label="Online type" value={draftOnlineType} options={onlineTypes} onChange={setDraftOnlineType} placeholder="Select format" />
                <SelectField label="Regions" value={draftRegions} options={regions} onChange={setDraftRegions} placeholder="Select region" />
              </div>

              <div className="mt-6 flex flex-col gap-2.5 sm:flex-row">
                <button
                  type="button"
                  onClick={handleSearch}
                  className="event-btn inline-flex flex-1 items-center justify-center gap-1.5 rounded-xl px-4 py-2.5 text-[0.85rem] font-bold text-white shadow-[0_12px_26px_rgba(218,33,40,0.24)] transition duration-300 hover:-translate-y-0.5"
                >
                  <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.4">
                    <circle cx="11" cy="11" r="7" />
                    <path d="m20 20-3.5-3.5" />
                  </svg>
                  Search
                </button>
                <button
                  type="button"
                  onClick={handleClear}
                  className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-[#DA2128]/20 bg-white px-4 py-2.5 text-[0.85rem] font-bold text-[#DA2128] transition duration-300 hover:bg-[#FEF7F4]"
                >
                  <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
                    <path d="M3 6h18" />
                    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                  </svg>
                  Clear filters
                </button>
              </div>

              <div className="mt-5 rounded-xl border border-[#F59C00]/20 bg-[#FFF8F1] p-3.5">
                <p className="text-[0.65rem] font-extrabold uppercase tracking-[0.2em] text-[#DB6400]">Need assistance?</p>
                <p className="mt-1.5 text-[0.8rem] leading-5 text-[#5C5569]">
                  Looking to partner, sponsor, or nominate for an awards category? Connect with the events desk.
                </p>
                <button type="button" className="mt-3 inline-flex items-center gap-1.5 text-[0.8rem] font-extrabold text-[#DA2128] transition hover:gap-2.5">
                  Contact Team
                  <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
                    <path d="M5 12h14" />
                    <path d="m13 5 7 7-7 7" />
                  </svg>
                </button>
              </div>
            </aside>

            {/* Main */}
            <main className="space-y-5">
              <div className="event-fade-up rounded-[28px] border border-[#DA2128]/10 bg-white/90 p-5 shadow-[0_18px_44px_rgba(218,33,40,0.07)] backdrop-blur-xl sm:p-6">
                <div className="flex flex-col gap-5 border-b border-[#DA2128]/10 pb-5 lg:flex-row lg:items-end lg:justify-between">
                  <div className="space-y-3">
                    <span className="inline-flex items-center gap-1.5 rounded-full border border-[#DA2128]/15 bg-[#FEF7F4] px-3 py-1 text-[0.65rem] font-black uppercase tracking-[0.22em] text-[#DA2128]">
                      <span className="h-1.5 w-1.5 rounded-full bg-[#DA2128] animate-pulse" />
                      Premium Events Directory
                    </span>
                    <div>
                      <h1 className="mt-2 font-heading text-3xl font-extrabold leading-tight text-[#161224] md:text-[32px]">
                        {headerLabel}
                      </h1>
                    </div>
                  </div>

                  <div className="relative flex items-center gap-1 self-start rounded-full border border-[#DA2128]/10 bg-[#FFFCFA] p-1 shadow-inner">
                    <div
                      className={`pointer-events-none absolute top-1 h-[calc(100%-8px)] w-[calc(62%-6px)] rounded-full shadow-[0_8px_18px_rgba(218,33,40,0.22)] transition-all duration-500 ease-[cubic-bezier(.2,.8,.2,1)] ${
                        activeTab === "forthcoming"
                          ? "left-1 bg-gradient-to-r from-[#DA2128] to-[#F59C00]"
                          : "left-[calc(50%+1px)] bg-gradient-to-r from-[#DB2628] to-[#DB6400]"
                      }`}
                    />
                    <button
                      type="button"
                      onClick={() => handleTab("forthcoming")}
                      className={`relative z-10 rounded-full px-4 py-2 text-[0.8rem] font-bold transition-colors duration-300 ${
                        activeTab === "forthcoming" ? "text-white" : "text-[#574D64] hover:text-[#DA2128]"
                      }`}
                    >
                      Forthcoming
                    </button>
                    <button
                      type="button"
                      onClick={() => handleTab("past")}
                      className={`relative z-10 rounded-full px-4 py-2 text-[0.8rem] font-bold transition-colors duration-300 ${
                        activeTab === "past" ? "text-white" : "text-[#574D64] hover:text-[#DA2128]"
                      }`}
                    >
                      Past Event
                    </button>
                  </div>
                </div>

                <div key={animKey} className="event-fade-in mt-5 flex flex-col gap-3.5 sm:flex-row sm:items-center sm:justify-between">
                  <div className="flex flex-wrap items-center gap-4">
                    <div className="rounded-xl bg-[#FEF7F4] px-3.5 py-2.5">
                      <p className="text-[0.65rem] font-bold uppercase tracking-[0.18em] text-[#DB6400]">Results</p>
                      <p className="font-heading mt-0.5 text-2xl font-black text-[#0F0B1D]">
                        <AnimatedNumber value={totalCount} />
                      </p>
                    </div>
                    <div>
                      <h2 className="font-heading text-xl font-black text-[#0F0B1D]">Events ({totalCount})</h2>
                      <p className="mt-0.5 text-[0.85rem] font-medium text-[#5D556A]">
                        {totalCount === 0 ? "No events match your filters" : `Showing results 1 to ${Math.min(10, totalCount)}`}
                      </p>
                    </div>
                  </div>
                  <div className="inline-flex items-center gap-1.5 rounded-full bg-[#EEF1FF] px-3.5 py-1.5 text-[0.8rem] font-semibold text-[#4B57B9] shadow-sm">
                    <span className="inline-flex h-2 w-2 rounded-full bg-[#5A68D8] animate-pulse" />
                    Status: {statusLabel}
                  </div>
                </div>

                {applied.keywords || applied.eventType || applied.subject ? (
                  <div className="mt-4 flex flex-wrap items-center gap-1.5">
                    <span className="text-[0.65rem] font-bold uppercase tracking-[0.16em] text-[#8A7981]">Active filters:</span>
                    {applied.keywords && (
                      <span className="inline-flex items-center gap-1.5 rounded-full border border-[#DA2128]/20 bg-[#FEF7F4] px-2.5 py-0.5 text-[0.7rem] font-bold text-[#DA2128]">
                        "{applied.keywords}"
                      </span>
                    )}
                    {applied.eventType && (
                      <span className="inline-flex items-center gap-1.5 rounded-full border border-[#DB6400]/20 bg-[#FFF8F1] px-2.5 py-0.5 text-[0.7rem] font-bold text-[#DB6400]">
                        {applied.eventType}
                      </span>
                    )}
                    {applied.subject && (
                      <span className="inline-flex items-center gap-1.5 rounded-full border border-[#F59C00]/30 bg-[#FFF8F1] px-2.5 py-0.5 text-[0.7rem] font-bold text-[#B96200]">
                        {applied.subject}
                      </span>
                    )}
                  </div>
                ) : null}
              </div>

              <div key={`list-${animKey}`} className="grid gap-4">
                {activeEvents.length === 0 ? (
                  <div className="event-fade-up rounded-[24px] border border-dashed border-[#DA2128]/25 bg-white/80 p-8 text-center shadow-[0_12px_32px_rgba(218,33,40,0.06)]">
                    <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#F59C00] text-white shadow-[0_12px_24px_rgba(218,33,40,0.24)]">
                      <svg viewBox="0 0 24 24" className="h-6 w-6 fill-none" stroke="currentColor" strokeWidth="2.2">
                        <circle cx="11" cy="11" r="7" />
                        <path d="m20 20-3.5-3.5" />
                      </svg>
                    </div>
                    <h3 className="font-heading mt-4 text-xl font-black text-[#161224]">No matching events found</h3>
                    <p className="mx-auto mt-2 max-w-md text-[0.85rem] leading-6 text-[#5D556A]">
                      Try clearing some filters or switching the event status. Use broader keywords like fintech, awards, summit, or conclave.
                    </p>
                    <button
                      type="button"
                      onClick={handleClear}
                      className="event-btn mt-5 inline-flex items-center gap-1.5 rounded-full px-5 py-2.5 text-[0.85rem] font-bold text-white shadow-[0_10px_22px_rgba(218,33,40,0.22)] transition hover:scale-[1.03]"
                    >
                      Reset all filters
                    </button>
                  </div>
                ) : (
                  activeEvents.map((event, index) => (
                    <EventCard
                      key={`${activeTab}-${event.title}-${animKey}`}
                      event={event}
                      active={activeTab === "forthcoming"}
                      index={index}
                    />
                  ))
                )}
              </div>

              <div className="event-fade-up relative overflow-hidden rounded-[24px] border border-[#DA2128]/10 bg-[linear-gradient(135deg,#DA2128_0%,#DB6400_55%,#F59C00_100%)] p-5 text-white shadow-[0_18px_44px_rgba(218,33,40,0.2)] sm:p-6">
                <div className="pointer-events-none absolute right-0 top-0 h-52 w-52 rounded-full bg-white/12 blur-3xl" />
                <div className="relative flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
                  <div>
                    <p className="text-[0.7rem] font-black uppercase tracking-[0.26em] text-white/80">Stay Updated</p>
                    <h3 className="font-heading mt-1.5 text-xl font-black sm:text-2xl">Never miss the next flagship event</h3>
                    <p className="mt-2 max-w-xl text-[0.85rem] leading-6 text-white/90">
                      Follow major conclaves, conferences, roadshows, awards, and summits across business, fintech, education, healthcare, manufacturing, and policy sectors.
                    </p>
                  </div>
                  <div className="flex flex-col gap-2.5 sm:flex-row">
                    <button
                      type="button"
                      className="inline-flex w-fit items-center gap-1.5 rounded-full bg-white px-5 py-2.5 text-[0.85rem] font-bold text-[#DA2128] shadow-[0_10px_22px_rgba(0,0,0,0.14)] transition duration-300 hover:scale-[1.03]"
                    >
                      Get Event Alerts
                      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none" stroke="currentColor" strokeWidth="2.2">
                        <path d="M5 12h14" />
                        <path d="m13 5 7 7-7 7" />
                      </svg>
                    </button>
                    <button
                      type="button"
                      className="inline-flex w-fit items-center gap-1.5 rounded-full border border-white/40 bg-white/10 px-5 py-2.5 text-[0.85rem] font-bold text-white backdrop-blur-sm transition duration-300 hover:bg-white/20"
                    >
                      Download Calendar
                    </button>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </section>
    </div>
  );
}
